import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import shouldReduceMemoryForDevice from 'owa-mail-store/lib/utils/shouldReduceMemoryForDevice';

export function isPrefetchDisabled(): boolean {
    if (isGlobalFeatureEnabled('fwk-prefetch-data-off')) {
        return true;
    }

    // Disable prefetch on low-memory devices (< 8 GB).
    // navigator.deviceMemory returns bucketed values: 0.25, 0.5, 1, 2, 4, 8.
    // A value < 8 reliably indicates the device has less than 8 GB of RAM.
    if (shouldReduceMemoryForDevice()) {
        return true;
    }

    return false;
}
